<template>
  <div>
    <Main
      :loading="loading"
      :tableData="tableData"
      :showDefaultImage="showDefaultImage"
    >
      <div class="side-frame-success" slot="header">
        <span style="font-size: 14px; color: #606266">{{
          $l('INDEX.order_spec_label_spec_title') || '产品规格'
        }}</span>
      </div>
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    orderCode: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
    tcOrderCode: { type: String, default: '' },
    showDefaultImage: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsCode) return
      this.loading = true
      this.$api
        .tcOrderGoodsSpecListApi({
          orderGoodsCode: this.orderGoodsCode,
          orderCode: this.orderCode,
          tcOrderCode: this.tcOrderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
  },
}
</script>
